import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { all_routes } from "../../../router/all_routes";
import { admininputs } from "../../../../core/common/inputoption/inputoption";
import { schoolClassId, classSectionId } from "../../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../../core/common/commonSelect";
import CustomInput from "../../../../core/common/commonInput";
// import CustomFileInput from "../../../../core/common/CustomFileInput";
import WebcamCapture from "../../../../core/common/WebcamCapture";
import {
  addAdminApi,
  updateAdminApi,
  fetchAdminRoleApi,
  fetchStatesApi,
  fetchDistrictsByStateApi,
  fetchBlocksByDistrictApi,
  fetchVillagesByBlockAreaApi,
  fetchSchoolsByVillageWardApi,
  updateSchoolHeadmasterApi,
  getCurrentUserRoleType,
  getCurrentUserEntity,
  updateUserAssignedRoleApi,
  getUserAssignedRoleApi
} from "../../../../core/data/services/adminService";
import { addadminSuccess } from "../../../../core/data/redux/adminSlice";
import { getMandatoryFields } from "../../../../core/common/commonServices";
import { AppDispatch } from "../../../../core/data/redux/store";
import SuccessModal from "../../../../core/common/successModal";
import ErrorModal from "../../../../core/common/ErrorModal";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { REACT_APP_AWS_REGION, REACT_APP_AWS_ACCESS_KEY_ID, REACT_APP_AWS_SECRET_ACCESS_KEY, REACT_APP_AWS_S3_BUCKET_NAME } from "../../../../constants/constants"
import { Admin } from "../../../../core/data/types/admin";

type Option = { label: string; value: string };

interface Role {
  id: number;
  name: string;
  isActive: boolean;
  isDeleted: boolean;
  roleKey: string;
  referenceKey: string;
  description: string;
  tier: string;
  createdAt: string;
  updatedAt: string;
}

interface State {
  id: number;
  name: string;
  code: string | null;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

interface District {
  id: number;
  stateId: number;
  name: string;
  code: string;
  isDeleted: boolean;
  createdBy: number;
  updatedBy: number | null;
  createdAt: string;
  updatedAt: string | null;
}

interface Block {
  id: number;
  districtId: number;
  name: string;
  isDeleted: boolean;
  createdBy: number;
  updatedBy: number | null;
  createdAt: string;
  updatedAt: string | null;
}

interface Village {
  id: number;
  blockAreaId: number; // Updated to blockAreaId
  name: string;
  isDeleted: boolean;
  createdBy: number;
  updatedBy: number | null;
  createdAt: string;
  updatedAt: string | null;
}

// NEW: School interface
interface School {
  id: number;
  name: string;
  schoolCode: string;
  udiseCode: string;
  address: string;
  phone: string;
  shift: string;
  gender: string;
  hmId: string;
  isActive: boolean;
  isDeleted: boolean;
  villageWardId: number;
  blockAreaId: number;
  districtId: number;
  stateId: number;
  schoolType: string;
  locationType: string;
  areaType: string;
  kitchenType: string;
}

// Configure AWS SDK (DANGER: Do not use real credentials in production)
const s3 = new S3Client({
  region: REACT_APP_AWS_REGION || "us-east-1",
  credentials: {
    accessKeyId: REACT_APP_AWS_ACCESS_KEY_ID || "YOUR_AWS_ACCESS_KEY_ID",
    secretAccessKey: REACT_APP_AWS_SECRET_ACCESS_KEY || "YOUR_AWS_SECRET_ACCESS_KEY",
  },
});

async function uploadFileToS3(file: File): Promise<string> {
  const maxSize = 4 * 1024 * 1024;
  if (file.size > maxSize) {
    throw new Error("File size exceeds 4MB limit");
  }

  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml'];
  if (!allowedTypes.includes(file.type)) {
    throw new Error("Invalid file type. Only JPG, PNG, and SVG are allowed");
  }

  const timestamp = Date.now();
  const randomString = Math.random().toString(36).substring(2, 15);
  const fileExtension = file.name.split('.').pop()?.toLowerCase();
  const fileName = `uploads/${timestamp}_${randomString}.${fileExtension}`;

  try {
    const arrayBuffer = await file.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);

    const command = new PutObjectCommand({
      Bucket: REACT_APP_AWS_S3_BUCKET_NAME,
      Key: fileName,
      Body: uint8Array,
      ContentType: file.type,
    });

    const result = await s3.send(command);
    console.log("S3 upload successful:", result);

    const s3Url = `https://${REACT_APP_AWS_S3_BUCKET_NAME}.s3.${REACT_APP_AWS_REGION}.amazonaws.com/${fileName}`;
    return s3Url;
  } catch (error) {
    console.error("S3 upload error:", error);

    if (error instanceof Error) {
      if (error.message.includes('AccessDenied')) {
        throw new Error("Access denied. Check your AWS credentials and permissions.");
      } else if (error.message.includes('NoSuchBucket')) {
        throw new Error("S3 bucket not found. Check your bucket name.");
      } else {
        throw new Error(`Upload failed: ${error.message}`);
      }
    }

    throw new Error("Unknown error occurred during upload");
  }
}

const validateTeacherForm = (formData: Omit<Admin, "id">, mandatoryFields: string[]) => {
  const errors: { [key: string]: string } = {};

  mandatoryFields.forEach((field) => {
    if (!formData[field as keyof typeof formData] ||
      String(formData[field as keyof typeof formData]).trim() === "") {
      errors[field] = `${field} is required`;
    }
  });

  if (formData.firstName && formData.firstName.trim().length < 3) {
    errors.firstName = "First name must be at least 3 characters long";
  }

  // if (formData.phone) {
  //   const phoneRegex = /^\d{10}$/;
  //   if (!phoneRegex.test(formData.phone)) {
  //     errors.phone = "Phone number must be exactly 10 digits";
  //   }
  // }

  // if (formData.aadharNumber) {
  //   const aadharRegex = /^\d{12}$/;
  //   if (!aadharRegex.test(formData.aadharNumber)) {
  //     errors.aadharNumber = "Aadhar number must be exactly 12 digits";
  //   }
  // }

  // if (formData.email) {
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   if (!emailRegex.test(formData.email)) {
  //     errors.email = "Please enter a valid email address";
  //   }
  // }

  return errors;
};

const getInitialFormState = (): Omit<Admin, "id"> => ({
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  profileImage: "",
  aadharNumber: "",
  designation: "",
  schoolClassId: "",
  classSectionId: "",
  roleIds: [1],
  parameters: [],
  uarIds: []
});

const AdminForm: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { state } = useLocation();
  const teacherFromState = state?.teacher as Admin | undefined;
  const isEdit = Boolean(teacherFromState);

  const [formData, setFormData] = useState<Omit<Admin, "id">>(getInitialFormState());
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [roles, setRoles] = useState<Role[]>([]);
  const [states, setStates] = useState<State[]>([]);
  const [districts, setDistricts] = useState<District[]>([]);
  const [blocks, setBlocks] = useState<Block[]>([]);
  const [villages, setVillages] = useState<Village[]>([]);
  const [schools, setSchools] = useState<School[]>([]); // NEW: Schools state
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
  const [selectedStateForDistrict, setSelectedStateForDistrict] = useState<number | null>(null);
  const [selectedDistrictForBlock, setSelectedDistrictForBlock] = useState<number | null>(null);
  const [selectedBlockAreaForVillage, setSelectedBlockAreaForVillage] = useState<number | null>(null);
  const [, setSelectedVillageForSchool] = useState<number | null>(null); // NEW: Village for school (kept for other admin types)
  const [currentUserRoleType, setCurrentUserRoleType] = useState<'admin' | 'state' | 'district' | 'block' | 'villageWard' | 'schoolHm' | null>(null);
  const [currentUserEntity, setCurrentUserEntity] = useState<any>(null);

  // Success modal state
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");

  // Error modal state
  const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  // Loading state
  const [loading, setLoading] = useState<boolean>(false);

  // NEW: Image capture states
  const [showCaptureModal, setShowCaptureModal] = useState<boolean>(false);
  const [imageUploading, setImageUploading] = useState<boolean>(false);

  // Compute mandatory fields once
  const mandatoryFields = getMandatoryFields(admininputs);

  // Get current user info on component mount
  useEffect(() => {
    const userRoleType = getCurrentUserRoleType();
    const userEntity = getCurrentUserEntity();
    setCurrentUserRoleType(userRoleType);
    setCurrentUserEntity(userEntity);

    if (!userRoleType) {
      setErrorMessage("Unauthorized: Unable to determine user role");
      setShowErrorModal(true);
      return;
    }

    if (userRoleType === 'schoolHm') {
      setErrorMessage("Unauthorized: Headmasters cannot create other users");
      setShowErrorModal(true);
      return;
    }
  }, []);

  // UPDATED: Added schoolHm support
  const getRoleType = (role: Role): 'admin' | 'state' | 'district' | 'block' | 'villageWard' | 'schoolHm' => {
    const tier = role.tier?.toLowerCase() || '';
    if (tier === 'admin') return 'admin';
    if (tier === 'state') return 'state';
    if (tier === 'district') return 'district';
    if (tier === 'block') return 'block';
    if (tier === 'villageward' || tier === 'village') return 'villageWard';
    if (tier === 'schoolhm' || tier === 'headmaster') return 'schoolHm'; // NEW
    return 'admin';
  };

  // Create dynamic options map
  const optionsMap: Record<string, Option[]> = {
    designation: roles.map(role => ({
      label: role.name,
      value: role.name
    })),
    schoolClassId,
    classSectionId,
    states: states.map(state => ({
      label: state.name,
      value: state.id.toString()
    })),
    districts: districts.map(district => ({
      label: district.name,
      value: district.id.toString()
    })),
    blocks: blocks.map(block => ({
      label: block.name,
      value: block.id.toString()
    })),
    villages: villages.map(village => ({
      label: village.name,
      value: village.id.toString()
    })),
    schools: schools.map(school => ({ // NEW: Schools options
      label: `${school.name} (${school.udiseCode})`,
      value: school.id.toString()
    }))
  };

  // Fetch roles on component mount (filtered based on current user's role)
  useEffect(() => {
    if (!currentUserRoleType) return;

    const fetchRoles = async () => {
      try {
        const response = await fetchAdminRoleApi();
        if (response.data && Array.isArray(response.data)) {
          setRoles(response.data);
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
        setErrorMessage("Failed to load roles. Please try again.");
        setShowErrorModal(true);
      }
    };

    fetchRoles();
  }, [currentUserRoleType]);

  // Fetch states when needed
  useEffect(() => {
    if (!selectedRole || !currentUserRoleType) return;

    const roleType = getRoleType(selectedRole);
    if ((roleType === 'state' || roleType === 'district') && currentUserRoleType === 'admin') {
      const fetchStates = async () => {
        try {
          const statesData = await fetchStatesApi();
          setStates(statesData);
        } catch (error) {
          console.error("Error fetching states:", error);
          setErrorMessage("Failed to load states. Please try again.");
          setShowErrorModal(true);
        }
      };

      fetchStates();
    } else if (roleType === 'district' && currentUserRoleType === 'state' && currentUserEntity?.states) {
      setSelectedStateForDistrict(currentUserEntity.states.id);
      const fetchDistricts = async () => {
        try {
          const districtsData = await fetchDistrictsByStateApi(currentUserEntity.states.id);
          setDistricts(districtsData);
        } catch (error) {
          console.error("Error fetching districts:", error);
          setErrorMessage("Failed to load districts. Please try again.");
          setShowErrorModal(true);
        }
      };

      fetchDistricts();
    }
  }, [selectedRole, currentUserRoleType, currentUserEntity]);

  // Handle district and block fetching
  useEffect(() => {
    if (!selectedRole || !currentUserRoleType) return;

    const roleType = getRoleType(selectedRole);
    if (roleType === 'district' && selectedStateForDistrict) {
      const fetchDistricts = async () => {
        try {
          const districtsData = await fetchDistrictsByStateApi(selectedStateForDistrict);
          setDistricts(districtsData);
        } catch (error) {
          console.error("Error fetching districts:", error);
          setErrorMessage("Failed to load districts. Please try again.");
          setShowErrorModal(true);
        }
      };

      fetchDistricts();
    } else if (roleType === 'block' || roleType === 'villageWard') {
      if (currentUserRoleType === 'admin') {
        // Admin needs to select state and district first
      } else if (currentUserRoleType === 'state' && currentUserEntity?.states) {
        setSelectedStateForDistrict(currentUserEntity.states.id);
        const fetchDistricts = async () => {
          try {
            const districtsData = await fetchDistrictsByStateApi(currentUserEntity.states.id);
            setDistricts(districtsData);
          } catch (error) {
            console.error("Error fetching districts:", error);
            setErrorMessage("Failed to load districts. Please try again.");
            setShowErrorModal(true);
          }
        };

        fetchDistricts();
      } else if (currentUserRoleType === 'district' && currentUserEntity?.districts) {
        setDistricts([currentUserEntity.districts]);
        setSelectedDistrictForBlock(currentUserEntity.districts.id);
      } else if (currentUserRoleType === 'block' && currentUserEntity?.blockAreas) {
        // Block admin - set their block area directly
        setBlocks([currentUserEntity.blockAreas]);
        setSelectedBlockAreaForVillage(currentUserEntity.blockAreas.id);
      }
    } else {
      setDistricts([]);
    }
  }, [selectedRole, selectedStateForDistrict, currentUserRoleType, currentUserEntity]);

  // Handle block fetching
  useEffect(() => {
    if (selectedRole && (getRoleType(selectedRole) === 'block' || getRoleType(selectedRole) === 'villageWard') && selectedDistrictForBlock) {
      const fetchBlocks = async () => {
        try {
          const blocksData = await fetchBlocksByDistrictApi(selectedDistrictForBlock);
          setBlocks(blocksData);
        } catch (error) {
          console.error("Error fetching blocks:", error);
          setErrorMessage("Failed to load blocks. Please try again.");
          setShowErrorModal(true);
        }
      };

      fetchBlocks();
    } else {
      // Don't clear blocks if user is block admin
      if (currentUserRoleType !== 'block') {
        setBlocks([]);
      }
    }
  }, [selectedRole, selectedDistrictForBlock, currentUserRoleType]);

  // Handle village fetching for village ward admins
  useEffect(() => {
    if (selectedRole && getRoleType(selectedRole) === 'villageWard') {
      let blockAreaId = selectedBlockAreaForVillage;
      if (currentUserRoleType === 'block' && currentUserEntity?.blockAreas && !blockAreaId) {
        blockAreaId = currentUserEntity.blockAreas.id;
        setSelectedBlockAreaForVillage(blockAreaId);
      }

      if (blockAreaId !== null && blockAreaId !== undefined) {
        const fetchVillages = async () => {
          try {
            const villagesData = await fetchVillagesByBlockAreaApi(blockAreaId as number);
            setVillages(villagesData);
          } catch (error) {
            console.error("Error fetching villages:", error);
            setErrorMessage("Failed to load villages. Please try again.");
            setShowErrorModal(true);
          }
        };

        fetchVillages();
      } else {
        console.log('No block area ID available for village fetch');
      }
    } else {
      setVillages([]);
    }
  }, [selectedRole, selectedBlockAreaForVillage, currentUserRoleType, currentUserEntity]);

  // NEW: Handle school fetching for headmaster roles (simplified for village admins)
  useEffect(() => {
    if (selectedRole && getRoleType(selectedRole) === 'schoolHm') {
      // For village admins, automatically load schools from their village
      if (currentUserRoleType === 'villageWard' && currentUserEntity?.villageWards) {
        const fetchSchools = async () => {
          try {
            const schoolsData = await fetchSchoolsByVillageWardApi(currentUserEntity.villageWards.id);
            setSchools(schoolsData);
          } catch (error) {
            console.error("Error fetching schools:", error);
            setErrorMessage("Failed to load schools. Please try again.");
            setShowErrorModal(true);
          }
        };

        fetchSchools();
      }
    } else {
      setSchools([]);
    }
  }, [selectedRole, currentUserRoleType, currentUserEntity]);

  useEffect(() => {
    if (isEdit && teacherFromState) {
      const { id, ...rest } = teacherFromState;
      setFormData(rest);
      const existingRole = roles.find(role => role.id === rest.roleIds[0]);
      if (existingRole) {
        setSelectedRole(existingRole);
      }
    }
  }, [isEdit, teacherFromState, roles]);

  const handleInputChange = (key: keyof Omit<Admin, "id">, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
    //const newErrors = validateTeacherForm(formData, mandatoryFields);

    // setErrors(prev => ({
    //   ...prev,
    //   [key]: newErrors[key as string] || ""
    // }));
    // setErrors((prev) => {
    //   const newValue = newErrors[key as string];
    //   if (newValue) {
    //     return { ...prev, [key as string]: newValue };
    //   } else {
    //     const { [key as string]: _, ...rest } = prev;
    //     return rest;
    //   }
    // });
  };

  const handleSelectChange = (key: keyof Omit<Admin, "id">) => (selected: any) => {
    const selectedValue = selected?.value || "";

    if (key === "designation") {
      const selectedRoleObj = roles.find(role => role.name === selectedValue);
      if (selectedRoleObj) {
        setSelectedRole(selectedRoleObj);
        setSelectedStateForDistrict(null);
        setSelectedDistrictForBlock(null);
        setSelectedBlockAreaForVillage(null);
        setSelectedVillageForSchool(null); // NEW: Reset village for school
        setDistricts([]);
        setBlocks([]);
        setVillages([]);
        setSchools([]); // NEW: Reset schools
        setFormData(prev => ({
          ...prev,
          designation: selectedValue,
          roleIds: [selectedRoleObj.id],
          parameters: []
        }));

        // Auto-set for various admin types
        if (currentUserRoleType === 'block' && getRoleType(selectedRoleObj) === 'villageWard' && currentUserEntity?.blockAreas) {
          setSelectedBlockAreaForVillage(currentUserEntity.blockAreas.id);
          setBlocks([currentUserEntity.blockAreas]);
        }

        // NEW: Auto-load schools for village admin selecting headmaster role
        if (currentUserRoleType === 'villageWard' && getRoleType(selectedRoleObj) === 'schoolHm' && currentUserEntity?.villageWards) {
          // Schools will be loaded automatically by the useEffect
        }
      } else {
        handleInputChange(key, selectedValue);
      }
    } else {
      handleInputChange(key, selectedValue);
    }
  };

  const handleStateForDistrictChange = (selected: any) => {
    const selectedValue = selected?.value || "";
    if (selectedValue) {
      setSelectedStateForDistrict(parseInt(selectedValue));
      setSelectedDistrictForBlock(null);
      setSelectedBlockAreaForVillage(null);
      setSelectedVillageForSchool(null); // NEW
      setBlocks([]);
      setVillages([]);
      setSchools([]); // NEW
      setFormData(prev => ({
        ...prev,
        parameters: []
      }));
    } else {
      setSelectedStateForDistrict(null);
      setSelectedDistrictForBlock(null);
      setSelectedBlockAreaForVillage(null);
      setSelectedVillageForSchool(null); // NEW
      setDistricts([]);
      setBlocks([]);
      setVillages([]);
      setSchools([]); // NEW
      setFormData(prev => ({
        ...prev,
        parameters: []
      }));
    }
  };

  const handleDistrictForBlockChange = (selected: any) => {
    const selectedValue = selected?.value || "";
    if (selectedValue) {
      setSelectedDistrictForBlock(parseInt(selectedValue));
      setSelectedBlockAreaForVillage(null);
      setSelectedVillageForSchool(null); // NEW
      setVillages([]);
      setSchools([]); // NEW
      setFormData(prev => ({
        ...prev,
        parameters: []
      }));
    } else {
      setSelectedDistrictForBlock(null);
      setSelectedBlockAreaForVillage(null);
      setSelectedVillageForSchool(null); // NEW
      setBlocks([]);
      setVillages([]);
      setSchools([]); // NEW
      setFormData(prev => ({
        ...prev,
        parameters: []
      }));
    }
  };

  const handleBlockAreaForVillageChange = (selected: any) => {
    const selectedValue = selected?.value || "";
    if (selectedValue) {
      setSelectedBlockAreaForVillage(parseInt(selectedValue));
      setSelectedVillageForSchool(null); // NEW
      setSchools([]); // NEW
      setFormData(prev => ({
        ...prev,
        parameters: []
      }));
    } else {
      setSelectedBlockAreaForVillage(null);
      setSelectedVillageForSchool(null); // NEW
      setVillages([]);
      setSchools([]); // NEW
      setFormData(prev => ({
        ...prev,
        parameters: []
      }));
    }
  };

  const handleParameterChange = (selected: any) => {
    const selectedValue = selected?.value || "";
    if (selectedValue) {
      setFormData(prev => ({
        ...prev,
        parameters: [parseInt(selectedValue)]
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        parameters: []
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setShowErrorModal(false);
    setErrorMessage("");
    setShowSuccessModal(false);
    setSuccessMessage("");

    const newErrors = validateTeacherForm(formData, mandatoryFields);

    if (selectedRole) {
      const roleType = getRoleType(selectedRole);
      if (roleType !== 'admin' && (!formData.parameters || formData.parameters.length === 0)) {
        const parameterName = roleType === 'state' ? 'state' :
          roleType === 'district' ? 'district' :
            roleType === 'block' ? 'block' :
              roleType === 'villageWard' ? 'village' :
                roleType === 'schoolHm' ? 'school' : 'parameter'; // NEW
        newErrors.parameters = `Please select a ${parameterName}`;
      }
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    setLoading(true);
    try {
      if (isEdit && teacherFromState) {
        // Check for changes in admin data
        const changedFields: Partial<Admin> & { id: number } = {
          id: teacherFromState.id as number,
        };
        let anyChange = false;
        let roleChanged = false;
        let parameterChanged = false;

        Object.keys(formData).forEach((key) => {
          const k = key as keyof Omit<Admin, "id">;
          if (JSON.stringify(formData[k]) !== JSON.stringify((teacherFromState as any)[k])) {
            (changedFields as any)[k] = formData[k];
            anyChange = true;

            if (k === 'roleIds') {
              roleChanged = true;
            }
            if (k === 'parameters') {
              parameterChanged = true;
            }
          }
        });

        if (!anyChange) {
          setSuccessMessage("No changes detected.");
          setShowSuccessModal(true);
        } else {
          // Update admin data
          const updatedResp = await updateAdminApi(changedFields as Admin);
          const updatedTeacher: Admin =
            (updatedResp as any).data ? (updatedResp as any).data : (updatedResp as Admin);

          // Update user role assignment if role or parameters changed
          if (roleChanged || parameterChanged) {
            const roleId = formData.roleIds[0];
            let uarId = null;

            // Try to get uarId from existing form data first
            if (formData.uarIds && formData.uarIds.length > 0) {
              uarId = formData.uarIds[0];
            } else if (teacherFromState.uarIds && teacherFromState.uarIds.length > 0) {
              uarId = teacherFromState.uarIds[0];
            } else if (teacherFromState.id) {
              // Fetch uarId from API if not available
              try {
                const userAssignedRoles = await getUserAssignedRoleApi(teacherFromState.id);
                if (userAssignedRoles.data && userAssignedRoles.data.length > 0) {
                  uarId = userAssignedRoles.data[0].id;
                }
              } catch (error) {
                console.error("Error fetching user assigned role:", error);
              }
            }

            const parameter = formData.parameters && formData.parameters.length > 0 ? formData.parameters[0] : undefined;

            if (uarId) {
              try {
                await updateUserAssignedRoleApi(uarId, roleId, parameter);
              } catch (roleError) {
                console.error("Error updating user role assignment:", roleError);
                setErrorMessage("Admin updated but role assignment failed. Please try updating the role again.");
                setShowErrorModal(true);
                setLoading(false);
                return;
              }
            } else {
              console.warn("No uarId found for role update");
              setErrorMessage("Admin updated but role assignment update failed. Missing user assignment ID.");
              setShowErrorModal(true);
              setLoading(false);
              return;
            }
          }

          dispatch(addadminSuccess(updatedTeacher));
          setSuccessMessage("Successfully updated!");
          setShowSuccessModal(true);
          navigate(all_routes.adminGrid);
        }
      } else {
        // Add new admin
        const addedResp = await addAdminApi(formData);
        const addedTeacher: Admin =
          (addedResp as any).data ? (addedResp as any).data : (addedResp as Admin);

        console.log("added teacher data :", addedTeacher);

        // Get uarId for role assignment
        let uarId = null;

        // Try to get uarId from response first
        if (addedTeacher.uarIds && addedTeacher.uarIds.length > 0) {
          uarId = addedTeacher.uarIds[0];
        } else if (addedTeacher.id) {
          // Fetch uarId from API if not in response
          try {
            const userAssignedRoles = await getUserAssignedRoleApi(addedTeacher.id);
            if (userAssignedRoles.data && userAssignedRoles.data.length > 0) {
              uarId = userAssignedRoles.data[0].id;
            }
          } catch (error) {
            console.error("Error fetching user assigned role:", error);
          }
        }

        if (uarId) {
          const roleId = formData.roleIds[0];
          const parameter = formData.parameters && formData.parameters.length > 0 ? formData.parameters[0] : undefined;

          try {
            await updateUserAssignedRoleApi(uarId, roleId, parameter);

            // NEW: If creating a headmaster, update the school's hmId
            if (selectedRole && getRoleType(selectedRole) === 'schoolHm' && parameter) {
              try {
                await updateSchoolHeadmasterApi(parameter, addedTeacher.id as number);
                console.log('School headmaster updated successfully');
              } catch (schoolError) {
                console.error('Error updating school headmaster:', schoolError);
                setErrorMessage("Headmaster created successfully, but failed to assign to school. Please update manually.");
                setShowErrorModal(true);
                setLoading(false);
                return;
              }
            }
          } catch (roleError) {
            console.error("Error setting user role assignment:", roleError);
            setErrorMessage("Admin created but role assignment failed. Please update the role manually.");
            setShowErrorModal(true);
            setLoading(false);
            return;
          }
        } else {
          console.warn("Could not find uarId for role assignment");
          setSuccessMessage("Admin created successfully, but role assignment may need manual update.");
        }

        dispatch(addadminSuccess(addedTeacher));
        setSuccessMessage("Successfully added!");
        setShowSuccessModal(true);
        navigate(all_routes.adminGrid);
        setFormData(getInitialFormState());
      }
      setErrors({});
    } catch (err: any) {
      console.error("Error submitting form:", err);

      let errorMessage = "Something went wrong. Please try again.";

      if (err?.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err.name === 'ApiError' && err.message) {
        errorMessage = err.message;
      } else if (err?.message && err.message !== "Request failed with status code 400") {
        errorMessage = err.message;
      }

      console.log("Final error message:", errorMessage);
      setErrorMessage(errorMessage);
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
    setErrorMessage("");
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    setSuccessMessage("");
  };

  const renderParameterField = () => {
    if (!selectedRole) return null;

    const roleType = getRoleType(selectedRole);

    if (roleType === 'admin') {
      return null;
    }

    const isState = roleType === 'state';
    const isDistrict = roleType === 'district';
    const isBlock = roleType === 'block';
    const isVillageWard = roleType === 'villageWard';
    const isSchoolHm = roleType === 'schoolHm'; // NEW

    if (isState) {
      return (
        <div className="col-xxl col-xl-3 col-md-6">
          <div className="mb-3">
            <label className="form-label">
              Select State
              <span style={{ color: "red" }}> *</span>
            </label>
            <CommonSelect
              className="select"
              options={optionsMap.states}
              defaultValue={
                isEdit && formData.parameters && formData.parameters.length > 0
                  ? {
                    value: formData.parameters[0].toString(),
                    label: states.find(s => s.id === formData.parameters[0])?.name || ''
                  }
                  : undefined
              }
              onChange={handleParameterChange}
            />
            {errors.parameters && (
              <div className="text-danger">{errors.parameters}</div>
            )}
          </div>
        </div>
      );
    }

    if (isDistrict) {
      return (
        <>
          {currentUserRoleType === 'admin' && (
            <div className="col-xxl col-xl-3 col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Select State
                  <span style={{ color: "red" }}> *</span>
                </label>
                <CommonSelect
                  className="select"
                  options={optionsMap.states}
                  defaultValue={
                    selectedStateForDistrict
                      ? {
                        value: selectedStateForDistrict.toString(),
                        label: states.find(s => s.id === selectedStateForDistrict)?.name || ''
                      }
                      : undefined
                  }
                  onChange={handleStateForDistrictChange}
                />
              </div>
            </div>
          )}

          {currentUserRoleType === 'state' && currentUserEntity?.states && (
            <div className="col-xxl col-xl-3 col-md-6">
              <div className="mb-3">
                <label className="form-label">State</label>
                <input
                  type="text"
                  className="form-control"
                  value={currentUserEntity.states.name}
                  disabled
                  style={{ backgroundColor: '#f8f9fa' }}
                />
                <small className="text-muted">Auto-selected based on your role</small>
              </div>
            </div>
          )}

          <div className="col-xxl col-xl-3 col-md-6">
            <div className="mb-3">
              <label className="form-label">
                Select District
                <span style={{ color: "red" }}> *</span>
              </label>
              <CommonSelect
                className="select"
                options={optionsMap.districts}
                defaultValue={
                  isEdit && formData.parameters && formData.parameters.length > 0
                    ? {
                      value: formData.parameters[0].toString(),
                      label: districts.find(d => d.id === formData.parameters[0])?.name || ''
                    }
                    : undefined
                }
                onChange={handleParameterChange}
                isDisabled={currentUserRoleType === 'admin' && !selectedStateForDistrict}
              />
              {errors.parameters && (
                <div className="text-danger">{errors.parameters}</div>
              )}
            </div>
          </div>
        </>
      );
    }

    if (isBlock) {
      return (
        <>
          {currentUserRoleType === 'admin' && (
            <div className="col-xxl col-xl-3 col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Select State
                  <span style={{ color: "red" }}> *</span>
                </label>
                <CommonSelect
                  className="select"
                  options={optionsMap.states}
                  defaultValue={
                    selectedStateForDistrict
                      ? {
                        value: selectedStateForDistrict.toString(),
                        label: states.find(s => s.id === selectedStateForDistrict)?.name || ''
                      }
                      : undefined
                  }
                  onChange={handleStateForDistrictChange}
                />
              </div>
            </div>
          )}

          {currentUserRoleType === 'state' && currentUserEntity?.states && (
            <div className="col-xxl col-xl-3 col-md-6">
              <div className="mb-3">
                <label className="form-label">State</label>
                <input
                  type="text"
                  className="form-control"
                  value={currentUserEntity.states.name}
                  disabled
                  style={{ backgroundColor: '#f8f9fa' }}
                />
                <small className="text-muted">Auto-selected based on your role</small>
              </div>
            </div>
          )}

          {(currentUserRoleType === 'admin' || currentUserRoleType === 'state') && (
            <div className="col-xxl col-xl-3 col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Select District
                  <span style={{ color: "red" }}> *</span>
                </label>
                <CommonSelect
                  className="select"
                  options={optionsMap.districts}
                  defaultValue={
                    selectedDistrictForBlock
                      ? {
                        value: selectedDistrictForBlock.toString(),
                        label: districts.find(d => d.id === selectedDistrictForBlock)?.name || ''
                      }
                      : undefined
                  }
                  onChange={handleDistrictForBlockChange}
                  isDisabled={currentUserRoleType === 'admin' && !selectedStateForDistrict}
                />
              </div>
            </div>
          )}

          {currentUserRoleType === 'district' && currentUserEntity?.districts && (
            <div className="col-xxl col-xl-3 col-md-6">
              <div className="mb-3">
                <label className="form-label">District</label>
                <input
                  type="text"
                  className="form-control"
                  value={currentUserEntity.districts.name}
                  disabled
                  style={{ backgroundColor: '#f8f9fa' }}
                />
                <small className="text-muted">Auto-selected based on your role</small>
              </div>
            </div>
          )}

          <div className="col-xxl col-xl-3 col-md-6">
            <div className="mb-3">
              <label className="form-label">
                Select Block
                <span style={{ color: "red" }}> *</span>
              </label>
              <CommonSelect
                className="select"
                options={optionsMap.blocks}
                defaultValue={
                  isEdit && formData.parameters && formData.parameters.length > 0
                    ? {
                      value: formData.parameters[0].toString(),
                      label: blocks.find(b => b.id === formData.parameters[0])?.name || ''
                    }
                    : undefined
                }
                onChange={handleParameterChange}
                isDisabled={!selectedDistrictForBlock}
              />
              {errors.parameters && (
                <div className="text-danger">{errors.parameters}</div>
              )}
            </div>
          </div>
        </>
      );
    }

    if (isVillageWard) {
      return (
        <>
          {/* Show current block info for block admins */}
          {currentUserRoleType === 'block' && currentUserEntity?.blockAreas && (
            <div className="col-xxl col-xl-3 col-md-6">
              <div className="mb-3">
                <label className="form-label">Block Area</label>
                <input
                  type="text"
                  className="form-control"
                  value={currentUserEntity.blockAreas.name}
                  disabled
                  style={{ backgroundColor: '#f8f9fa' }}
                />
                <small className="text-muted">Auto-selected based on your role</small>
              </div>
            </div>
          )}

          {/* Show block selection for other admin types */}
          {currentUserRoleType !== 'block' && (
            <div className="col-xxl col-xl-3 col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Select Block
                  <span style={{ color: "red" }}> *</span>
                </label>
                <CommonSelect
                  className="select"
                  options={optionsMap.blocks}
                  defaultValue={
                    selectedBlockAreaForVillage
                      ? {
                        value: selectedBlockAreaForVillage.toString(),
                        label: blocks.find(b => b.id === selectedBlockAreaForVillage)?.name || ''
                      }
                      : undefined
                  }
                  onChange={handleBlockAreaForVillageChange}
                  isDisabled={!selectedDistrictForBlock}
                />
              </div>
            </div>
          )}

          <div className="col-xxl col-xl-3 col-md-6">
            <div className="mb-3">
              <label className="form-label">
                Select Village
                <span style={{ color: "red" }}> *</span>
              </label>
              <CommonSelect
                className="select"
                options={optionsMap.villages}
                defaultValue={
                  isEdit && formData.parameters && formData.parameters.length > 0
                    ? {
                      value: formData.parameters[0].toString(),
                      label: villages.find(v => v.id === formData.parameters[0])?.name || ''
                    }
                    : undefined
                }
                onChange={handleParameterChange}
                isDisabled={!selectedBlockAreaForVillage && currentUserRoleType !== 'block'}
              />
              {errors.parameters && (
                <div className="text-danger">{errors.parameters}</div>
              )}
              {villages.length === 0 && selectedBlockAreaForVillage && (
                <small className="text-muted">No villages found for this block area</small>
              )}
            </div>
          </div>
        </>
      );
    }

    // NEW: School headmaster parameter field (simplified for village admins)
    if (isSchoolHm) {
      return (
        <>
          {/* Show current village info for village admins */}
          {currentUserRoleType === 'villageWard' && currentUserEntity?.villageWards && (
            <div className="col-xxl col-xl-3 col-md-6">
              <div className="mb-3">
                <label className="form-label">Village</label>
                <input
                  type="text"
                  className="form-control"
                  value={currentUserEntity.villageWards.name}
                  disabled
                  style={{ backgroundColor: '#f8f9fa' }}
                />
                <small className="text-muted">Auto-selected based on your role</small>
              </div>
            </div>
          )}

          <div className="col-xxl col-xl-3 col-md-6">
            <div className="mb-3">
              <label className="form-label">
                Select School
                <span style={{ color: "red" }}> *</span>
              </label>
              <CommonSelect
                className="select"
                options={optionsMap.schools}
                defaultValue={
                  isEdit && formData.parameters && formData.parameters.length > 0
                    ? {
                      value: formData.parameters[0].toString(),
                      label: schools.find(s => s.id === formData.parameters[0])?.name || ''
                    }
                    : undefined
                }
                onChange={handleParameterChange}
              />
              {errors.parameters && (
                <div className="text-danger">{errors.parameters}</div>
              )}
              {schools.length === 0 && currentUserRoleType === 'villageWard' && (
                <small className="text-muted">No schools found in your village</small>
              )}
            </div>
          </div>
        </>
      );
    }

    return null;
  };

  // Show unauthorized message if user doesn't have permission
  if (!currentUserRoleType || currentUserRoleType === 'schoolHm') {
    return (
      <div className="page-wrapper">
        <div className="content content-two">
          <div className="text-center">
            <h3>Unauthorized Access</h3>
            <p>You don't have permission to access this page.</p>
            <Link to={all_routes.adminGrid} className="btn btn-primary">
              Back to Admin List
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content content-two">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="mb-1">{isEdit ? "Edit" : "Add"} Admin</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminGrid}>Admin</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {isEdit ? "Edit" : "Add"} Admin
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <form onSubmit={handleSubmit}>
                <div className="card mb-4">
                  <div className="card-header bg-light">
                    <h4 className="text-dark">{isEdit ? "Edit" : "Add"} Admin</h4>
                    <small className="text-muted">
                      Current Role: {currentUserRoleType?.charAt(0).toUpperCase() + currentUserRoleType?.slice(1)} Admin
                      {currentUserEntity && (
                        <span>
                          {currentUserRoleType === 'state' && ` - ${currentUserEntity.states?.name}`}
                          {currentUserRoleType === 'district' && ` - ${currentUserEntity.districts?.name}`}
                          {currentUserRoleType === 'block' && ` - ${currentUserEntity.blockAreas?.name}`}
                          {currentUserRoleType === 'villageWard' && ` - ${currentUserEntity.villageWards?.name}`}
                        </span>
                      )}
                    </small>
                  </div>
                  <div className="card-body pb-1">
                    <div className="row row-cols-xxl-5 row-cols-md-6">
                      {admininputs.map(({ label, type, key, pattern, required, maxLength, errorMessage }: any) => (
                        <div className="col-xxl col-xl-3 col-md-6" key={key}>
                          <div className="mb-3">
                            <label className="form-label">
                              {label}
                              {required && <span style={{ color: "red" }}> *</span>}
                            </label>
                            {key === "profileImage" ? (
                              <div className="profile-upload">
                                {/* Display current image if exists */}
                                {formData.profileImage && (
                                  <img
                                    src={String(formData.profileImage)}
                                    alt="Profile Preview"
                                    style={{ width: 100, height: 100, objectFit: "cover", marginBottom: 10 }}
                                  />
                                )}

                                {imageUploading && <p>Uploading...</p>}

                                {/* File Upload Option */}
                                <div className="d-flex upload-option mb-3">
                                  <label htmlFor="profileImageUpload" className="btn btn-primary me-2">
                                    <i className="fas fa-upload me-2"></i>
                                    Upload Image
                                  </label>
                                  <input
                                    id="profileImageUpload"
                                    type="file"
                                    accept=".jpg,.jpeg,.png,.svg"
                                    style={{ display: 'none' }}
                                    onChange={async (e: React.ChangeEvent<HTMLInputElement>) => {
                                      const file = e.target.files?.[0];
                                      if (file) {
                                        // Validate file size (4MB limit)
                                        if (file.size > 4 * 1024 * 1024) {
                                          setErrorMessage("File size must be under 4MB");
                                          setShowErrorModal(true);
                                          return;
                                        }

                                        // Validate file type
                                        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml'];
                                        if (!allowedTypes.includes(file.type)) {
                                          setErrorMessage("Only JPG, PNG, and SVG formats are allowed");
                                          setShowErrorModal(true);
                                          return;
                                        }

                                        try {
                                          setImageUploading(true);
                                          console.log("Uploading file to S3:", file);
                                          const s3Url = await uploadFileToS3(file);
                                          handleInputChange("profileImage" as keyof Omit<Admin, "id">, s3Url);
                                        } catch (err: any) {
                                          console.error('Image upload failed:', err);
                                          setErrorMessage(`Image upload failed: ${err.message}`);
                                          setShowErrorModal(true);
                                        } finally {
                                          setImageUploading(false);
                                        }
                                      } else {
                                        handleInputChange("profileImage" as keyof Omit<Admin, "id">, null);
                                      }
                                    }}
                                  />

                                  {/* Camera Capture Button */}
                                  <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={() => setShowCaptureModal(true)}
                                  >
                                    <i className="fas fa-camera me-2"></i>
                                    Capture Image
                                  </button>
                                  {/* Remove Button */}
                                  {formData.profileImage && (
                                    <Link
                                      to="#"
                                      className="btn btn-danger ms-2"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleInputChange(
                                          "profileImage" as keyof Omit<Admin, "id">,
                                          null
                                        );
                                      }}
                                    >
                                      <i className="fas fa-trash me-2"></i>
                                      Remove
                                    </Link>
                                  )}
                                </div>

                                <p className="fs-12 mt-2 text-muted">
                                  Upload or capture image • Size under 4MB • JPG, PNG, SVG format only
                                </p>
                              </div>
                            ) : type === "select" ? (
                              <CommonSelect
                                className="select"
                                options={optionsMap[key] || []}
                                defaultValue={
                                  isEdit &&
                                    formData[key] !== null &&
                                    formData[key] !== ""
                                    ? { value: String(formData[key]), label: String(formData[key]) }
                                    : undefined
                                }
                                onChange={handleSelectChange(
                                  key as keyof Omit<Admin, "id">
                                )}
                              />
                            ) : (
                              <CustomInput
                                id={key}
                                className="form-control"
                                type={type}
                                placeholder={label}
                                value={String(formData[key as keyof typeof formData] || "")}
                                onChange={(e) =>
                                  handleInputChange(key as keyof Omit<Admin, "id">, e.target.value)
                                }
                                pattern={pattern}
                                maxLength={maxLength}
                                required={required}
                                errorMessage={errorMessage}
                                label={label}
                              />
                            )}
                            {errors[key] && (
                              <div className="text-danger">{errors[key]}</div>
                            )}
                          </div>
                        </div>
                      ))}

                      {/* Dynamic parameter field */}
                      {renderParameterField()}
                    </div>
                  </div>
                </div>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-light me-3"
                    onClick={() => navigate(all_routes.adminGrid)}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading
                      ? isEdit
                        ? "Saving..."
                        : "Adding..."
                      : isEdit
                        ? "Save Changes"
                        : "Add Admin"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Camera Capture Modal */}
      {showCaptureModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="fas fa-camera me-2"></i>
                  Capture Profile Image
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCaptureModal(false)}
                ></button>
              </div>
              <div className="modal-body text-center">
                <WebcamCapture
                  onCapture={async (file) => {
                    try {
                      setImageUploading(true);
                      setShowCaptureModal(false); // Close modal immediately after capture
                      const s3Url = await uploadFileToS3(file);
                      handleInputChange("profileImage" as keyof Omit<Admin, "id">, s3Url);
                    } catch (err: any) {
                      console.error("Profile image upload failed:", err);
                      setErrorMessage(`Profile image upload failed: ${err.message}`);
                      setShowErrorModal(true);
                    } finally {
                      setImageUploading(false);
                    }
                  }}
                />
                <p className="text-muted mt-3 mb-0">
                  Position your face in the camera frame and click capture
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowCaptureModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      <SuccessModal
        show={showSuccessModal}
        onClose={handleCloseSuccessModal}
        message={successMessage}
      />

      {/* Error Modal */}
      <ErrorModal
        show={showErrorModal}
        message={errorMessage}
        onClose={handleCloseErrorModal}
      />
    </>
  );
};

export default AdminForm;